import axios from "axios";
import Swal from "sweetalert2";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    env: "production",
    config: {
      production: {
        // yasale.zwiz.app
        liffid: "1656136806-YwgE9RjR",
        scandit: "ARlk4Z2BCaRqPjr3RSRhDedD1xQ8EuWPj0IcaAN9czdJb7gWn2cnaOtO68PyNtqddBbM5YlQ4vgwT8zcsl5kEMpfSS0qYkPHBmBi/1dL3mS9cLnGsHOM23BZW/cGTtyK914XksE3QuDrHUZTKAOI0KcJJ2RGOXYvgRtiNAkN7pcERr/F3PvnHnXu7avZcIcZ0/MposvfgwNbZVT4MoXfIHrwrFdmsSNVWbO02RXdPwYO/L459iv7M0EYG3ngrFVeiztIYaR7GpF8UC+IPgj8Gb2ZmHXbRzUH+xOZufhODZF3FWnibv0VWK+02VnuzAxcY9kXYaRrNth43rZfxD1hdVEvLfwcmej53MRTZJRcOIOyciWSch3MQlpNCyI4vnAb4C+0hgHvor35yZKhK6x/cr2JgU/pbe78oBj33R6ir31uMn6XvjzHybfUkRpq3yMQYcRgrcEjjelxNVBENrCcVm9+nnM6xNVqzcD4yLMLa9p3fICUwEmb32sZtZcD0bgzGXnOmLjdaI4KqDDkr96NkI0JREXsO5raYrNf1FwED7GrYA+i5swM/mLCfypTdX94AjEnnIjXnCn826fuVUc5nxc+gRZkmTr9ICbuLUrVrO1n5hBO/rxfSaOrHqE4R+UIvyoPUAajjRqpe3S7UdnxeayLPH8pwP7bleda49Wx5hJmV9H+BzQSTzTIh/c/uL0mRn3FwJgmfsHzBDz3e5u8UXvp1LEKlmJLn+lOln6+z6xYgWDqkrDSJoJJuYmnutIoOw5sgYoq0l3/PQYtMgJooJ5MxwZbFos9ZLQUXWXUgenNMm+8zDpn4G4svvp7TINafpnDNGyysfJyWQPsmeo=",
      },
      development: {
        // uat.yasale.zwiz.app
        liffid: "1656136806-drBy0Y7Y",
        scandit: "ASSR/SgWDPfoP6i7FjuSgIozinACOavw31nsQuVv1Qg4VUn67GkEb4RnNPBpNwSf7VuF4kpdHAQ9UGn15Tm6fhptUdfCftt9S1cvxW53X/ufSlZZkHEUX1FxLyxgTbnVd2onPgJbInrtSucc+2smSxV9krlqBtr20Sfx58xDH6W0P3SAKoxDPPnM0IY9Kp+HPWdmK4X7dJhcBf5qcQ4wrxquit1cZABorbjAbgmZl8GgsJI7sVvPtmwn5haeT3SWIg1UHjhMnsUhmLywu54OlzkkZXK2FS9OKEidbPOG3L67frSL2dX1oiJc6m7FguFK3NM3VGA1GnRuVJAUBemdrlLsz0bUjpiI2Cen6oEgFuXgZr0DuuT62fBeDB0Q4fdZM708QOdHR+lIa2LarZZL1NxweW62/UFBLiALoeA3Uv7WOz3qEAnLFFhbhK+xO5CRIvxRNzrr4Zueg6BA4zyyi/RzLH1ARqgIO7yCEF3zTikPPTlOdYv2QYsJJN9H9aj8pLf9BL6On0bhW4ZnYR8SJEOD/QvHUiJScqePIK0pujd7XM4+iue2i+Jhm/tejS2P/Vaot2Gff0te2mOtjymh5TrzSu79wRNFvHrpqABGmFP9JF9JaX8evPB8dNsq+RvepEtPCDaAJflGSyaS/Gp4gJWKiKXCe7zNPp+OFUyAsBAEb+9cGvU8EBL2ELrGOSNPJ8WtLN3BqTNv8hsjm7ZDh3vUVPfIL+tKi250pMQwXROqtbmNZY6bU3YOKhFAtSnwLCF8t8Icrm4xSjBFxAjlo0Zko5VS7aLCnAjmcyoC3bHLeqwha6IQCbQqP5mK0nFyrNaOi/ZmzvWSxL95RybqSKSi8/g=",
      },
      localhost: {
        // https://localhost:8080/
        liffid: "1656136806-xkyEakQk",
        scandit: "ASSR/SgWDPfoP6i7FjuSgIozinACOavw31nsQuVv1Qg4VUn67GkEb4RnNPBpNwSf7VuF4kpdHAQ9UGn15Tm6fhptUdfCftt9S1cvxW53X/ufSlZZkHEUX1FxLyxgTbnVd2onPgJbInrtSucc+2smSxV9krlqBtr20Sfx58xDH6W0P3SAKoxDPPnM0IY9Kp+HPWdmK4X7dJhcBf5qcQ4wrxquit1cZABorbjAbgmZl8GgsJI7sVvPtmwn5haeT3SWIg1UHjhMnsUhmLywu54OlzkkZXK2FS9OKEidbPOG3L67frSL2dX1oiJc6m7FguFK3NM3VGA1GnRuVJAUBemdrlLsz0bUjpiI2Cen6oEgFuXgZr0DuuT62fBeDB0Q4fdZM708QOdHR+lIa2LarZZL1NxweW62/UFBLiALoeA3Uv7WOz3qEAnLFFhbhK+xO5CRIvxRNzrr4Zueg6BA4zyyi/RzLH1ARqgIO7yCEF3zTikPPTlOdYv2QYsJJN9H9aj8pLf9BL6On0bhW4ZnYR8SJEOD/QvHUiJScqePIK0pujd7XM4+iue2i+Jhm/tejS2P/Vaot2Gff0te2mOtjymh5TrzSu79wRNFvHrpqABGmFP9JF9JaX8evPB8dNsq+RvepEtPCDaAJflGSyaS/Gp4gJWKiKXCe7zNPp+OFUyAsBAEb+9cGvU8EBL2ELrGOSNPJ8WtLN3BqTNv8hsjm7ZDh3vUVPfIL+tKi250pMQwXROqtbmNZY6bU3YOKhFAtSnwLCF8t8Icrm4xSjBFxAjlo0Zko5VS7aLCnAjmcyoC3bHLeqwha6IQCbQqP5mK0nFyrNaOi/ZmzvWSxL95RybqSKSi8/g=",
      },
    },
    currentPoint: 0,
    backgroundColor: "#fff",
    serverUrl: "https://api-enterprise.zwiz.app/",
    query: {},
    redirectview: "",
    member: {},
    profile: {},
    forgetPasswordData: {},
    headertext: "",
    input: {
      shopDistrict: "",
      shopProvince: "",
      shopSubDistrict: "",
      shopPostcode: "",
    },
    ref: null,
  },
  mutations: {},
  actions: {
    sendMessage({ state }, message) {
      var vm = this;
      return new Promise(async (resolve) => {
        var url = state.serverUrl + "zwiz-pushmsg-webbrowser";
        var data = {
          pageid: state.query.pageid,
          userid: state.userid,
          message,
        };
        if (await window.liff.isInClient()) {
          try {
            await window.liff.sendMessages([
              {
                text: message,
                type: "text",
              },
            ]);
            resolve();
          } catch (error) {
            alert(JSON.stringify(error));
            alert(JSON.stringify(error.message));
          }
        } else {
          axios
            .post(url, data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then(async (response) => {
              if (response.data.responsecode == 200) {
                resolve();
              } else {
                if (response.data.reason) {
                  await Swal.fire({
                    text: response.data.reason,
                  });
                  resolve();
                }
              }
            });
        }
      });
    },
    messengerClose() {
      MessengerExtensions.requestCloseBrowser(
        function success() {},
        function error() {
          window.close();
        }
      );
    },
  },
  modules: {},
});
